<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body" id="accommodationRequest">
                <!--<h5 class="card-title">Special title treatment</h5>-->
                <!-- {{ model }} -->
                <!-- {{ eventSettings }} -->

                <div class="row" v-if="model.tempRankingAccommodationRequestRequired">
                    <div class="form-group col-12 mt-3">
                        <vs-checkbox v-model="model.participationDetails.accommodationRequired"
                                     :name="'accommodationRequired' + _uid"
                                     :id="'accommodationRequired' + _uid"
                                     style="justify-content: flex-start !important"
                                     aria-describedby="accommodationRequiredHelp">
                            {{ $t('participationConfirmation.accommodationRequired') }}
                        </vs-checkbox>
                        <small id="accommodationRequiredHelp" class="form-text text-muted">
                            {{$t('participationConfirmation.accommodationRequiredHelp')}}
                        </small>
                    </div>
                </div>

                <kendo-datasource ref="accommodationPlaceDatasource"
                                  :transport="transportSettings.accommodationPlaceTransportSettings"
                                  :server-filtering="true"
                                  :server-paging="false"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModels.accommodationPlaceSchemaModel"
                                  :error="dataSourceError">
                </kendo-datasource>

                <div class="row mb-3">
                    <div class="col-12 form-group" v-if="model.participationDetails.accommodationRequired === true">
                        <DateRange :required="true"
                                   :id="'requestDateRange' + _uid"
                                   :startTime.sync="model.participationDetails.accommodationRequest.fromDate"
                                   :endTime.sync="model.participationDetails.accommodationRequest.toDate"
                                   :format="customDateFormat"
                                   :showTime="false"
                                   :min="daterangeMinValue"
                                   :max="daterangeMaxValue"
                                   :startTitle="'participationConfirmation.fromDate'"
                                   :endTitle="'participationConfirmation.toDate'"
                                   :bindPopup="true"
                                   :popupContainerId="'#accommodationRequest'"
                                   :start-description="$t('participationConfirmation.fromDateDescription')"
                                   :end-description="$t('participationConfirmation.toDateDescription')" >
                        </DateRange>
                    </div>

                    <div class="col-12 form-group" v-if="model.participationDetails.accommodationRequired === true">
                        <label class="col-form-label font-weight-bold" :for="'accommodationPlace' + _uid">{{$t('participationConfirmation.accommodationPlace')}}</label>
                        <kendo-multicolumncombobox :data-source-ref="'accommodationPlaceDatasource'"
                                                   :data-text-field="'displayName'"
                                                   :data-value-field="'id'"
                                                   :name="'accommodationPlace' + _uid"
                                                   :id="'accommodationPlace' + _uid"
                                                   v-validate="model.participationDetails.accommodationRequired ? 'required' : ''"
                                                   :data-vv-as="$t('scheduler.venue')"
                                                   :clear-button="true"
                                                   :popup="popup"
                                                   v-model="model.participationDetails.accommodationRequest.accommodationPlaceId"
                                                   :placeholder="$t('choose')"
                                                   :no-data-template="$t('missingData')"
                                                   :filter="'contains'"
                                                   style="width:100%">
                            <kendo-multicolumncombobox-column :field="'name'"
                                                              :title="$t('registers.organizers.gridHeaders.name')">
                            </kendo-multicolumncombobox-column>
                            <kendo-multicolumncombobox-column :field="'address'"
                                                              :title="$t('address.cardTitle')">
                            </kendo-multicolumncombobox-column>
                        </kendo-multicolumncombobox>
                        <span class="text-danger" v-if="errors.has('accommodationPlace' + _uid)">{{ errors.first('accommodationPlace' + _uid) }}</span>
                    </div>

                    <div class="col-12 form-group" v-if="model.participationDetails.accommodationRequired === true">
                        <label class="col-form-label font-weight-bold" :for="'roomType' + _uid">{{$t('participationConfirmation.accommodationType')}}</label>
                        <kendo-dropdownlist v-model="model.participationDetails.accommodationRequest.accommodationTypeId"
                                            :data-source="roomsSource"
                                            :data-text-field="isEnVersion ? 'textEn' : 'text'"
                                            :data-value-field="'value'"
                                            :clear-button="true"
                                            :popup="popup"
                                            :disabled="!model.participationDetails.accommodationRequest.accommodationPlaceId"
                                            :optionLabel="$t('choose')"
                                            :name="'roomType' + _uid"
                                            :id="'roomType' + _uid"
                                            style="width:100%">
                        </kendo-dropdownlist>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-6 col-sm-12">
                        <vs-checkbox v-model="model.participationDetails.transportationRequired"
                                     :name="'transportationRequired' + _uid"
                                     :id="'transportationRequired' + _uid"
                                     style="justify-content: flex-start !important"
                                     aria-describedby="transportationRequiredHelp">
                            {{ $t('participationConfirmation.transportationRequired') }}
                        </vs-checkbox>
                        <small id="transportationRequiredHelp" class="form-text text-muted">
                            {{$t('participationConfirmation.transportationRequiredHelp')}}
                        </small>
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <vs-checkbox v-model="model.participationDetails.vegetarianMenuRequired"
                                     :name="'vegetarianMenuRequired' + _uid"
                                     :id="'vegetarianMenuRequired' + _uid"
                                     style="justify-content: flex-start !important"
                                     aria-describedby="vegetarianMenuRequiredHelp">
                            {{ $t('participationConfirmation.vegetarianMenuRequired') }}
                        </vs-checkbox>
                        <small id="vegetarianMenuRequiredHelp" class="form-text text-muted">
                            {{$t('participationConfirmation.vegetarianMenuRequiredHelp')}}
                        </small>
                    </div>
                </div>


                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'note' + _uid">{{ $t('participationConfirmation.note') }}</label>
                        <textarea rows="3" class="form-control" v-model="model.participationDetails.note" :id="'note' + _uid"></textarea>
                    </div>
                </div>

                <div v-if="model.isManualAddition">
                    <hr />
                    <div class="row">
                        <div class="col-md-4 col-sm-12 form-group">
                            <vs-checkbox v-model="model.isNotifiedByPhone"
                                         :name="'isNotifiedByPhone' + _uid"
                                         :id="'isNotifiedByPhone' + _uid"
                                         style="justify-content: flex-start !important">
                                {{ $t('registers.events.evaluation.tempRanking.isNotifiedByPhone') }}
                            </vs-checkbox>
                        </div>
                        <div class="col-md-4 col-sm-12 form-group" v-if="model.isNotifiedByPhone">
                            <label class="font-weight-bold" :for="'dateOfNotificationUtc' + _uid">{{$t('registers.events.evaluation.tempRanking.dateOfNotificationUtc')}}</label>
                            <DatePicker v-model="model.dateOfNotificationUtc"
                                        format="dd.MM.yyyy HH:mm"
                                        :name="'dateOfNotificationUtc' + _uid"
                                        :id="'dateOfNotificationUtc' + _uid"
                                        :fieldName="$t('registers.events.evaluation.tempRanking.dateOfNotificationUtc')"
                                        :convertDateToUtc="false"
                                        :bindPopup="true"
                                        :popupContainerId="'#accommodationRequest'">
                            </DatePicker>
                        </div>
                        <div class="col-md-4 col-sm-12 form-group" v-if="model.isNotifiedByPhone">
                            <label class="font-weight-bold" :for="'phoneOfNotificatiob' + _uid">{{$t('registers.events.evaluation.tempRanking.phoneOfNotification')}}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="model.phoneOfNotificatiob"
                                   :name="'phoneOfNotificatiob' + _uid"
                                   :id="'phoneOfNotificatiob' + _uid" />
                        </div>

                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Participation confirmation edit buttons">
                        <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TempRankingToPersonModel } from '@/models/models';
    import { Culture } from '@/models/enums';
    import DateRange from '@/components/dateTimeRange/DateTimeRange_new';
    import DatePicker from '@/components/datepicker/DateTimePicker';
    import tempRankingService from '@/services/tempRanking.service';
    import participantService from '@/services/participant.service';
    import { mapGetters } from 'vuex'

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: TempRankingToPersonModel,
                required: false
            }
        },
        components: {
            DateRange,
            DatePicker
        },
        data() {
            return {
                model: this.value,
                transportSettings: {
                    accommodationPlaceTransportSettings: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/accommodationPlace/getForEvent/`,
                            dataType: 'json',
                            type: 'POST',
                            contentType: 'application/json',
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.accommodationPlaceParameterMap
                    }
                },
                schemaModels: {
                    accommodationPlaceSchemaModel: {
                        id: {
                            name: 'id',
                            type: 'number',
                            editable: false,
                            nullable: false,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.id'
                        },
                        name: {
                            name: 'name',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.name'
                        },
                        displayName: {
                            name: 'displayName',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.name'
                        },
                        address: {
                            name: 'address',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'address.cardTitle'
                        },
                        contactName: {
                            name: 'contactName',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.contactName'
                        },
                        phone: {
                            name: 'phone',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.phone'
                        },
                        mobilePhone: {
                            name: 'mobilePhone',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'person.mobilePhone'
                        }
                    }
                },
                roomsSource: [
                    { text: "Единична", textEn: "Single", value: 1 },
                    { text: "Двойна", textEn: "Double", value: 2 },
                    { text: "Тройна", textEn: "Triple", value: 3 },
                    { text: "Апартамент", textEn: "Apartment", value: 4 }
                ],
                popup: {
                    appendTo: $("#accommodationRequest")
                },
                eventSettings: null
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            accommodationPlaceParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    let newOptions = { request: options, eventId: this.model.registerEntityId }
                    return kendo.stringify(newOptions);
                }
            },
            onCancel() {
                this.$emit("cancel");
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.doSave();
                    }
                });
            },
            doSave() {
                const participationDetailsId = Number(this.model.participationDetails.id);
                if (isNaN(participationDetailsId) || participationDetailsId <= 0) {
                    this.create();
                } else {
                    this.updateParticipationDetails();
                }
            },
            create() {
                kendo
                    .confirm(this.$t('registers.events.evaluation.tempRanking.confirmConfirmation'))
                    .then(
                        function () {
                            tempRankingService.confirmTampRanking(this.model)
                                .then(response => {
                                    this.$emit("save", this.model);

                                    this.$vs.notify({
                                        title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                        text: this.$helpers.responseMessage(response),
                                        color: 'success',
                                        time: this.$store.getters.notificationDuration
                                    });
                                })
                                .catch(error => {
                                    this.$vs.notify({
                                        title: this.$t(
                                            'request.response.status.' +
                                            this.$helpers.errorStatusCode(error)
                                        ),
                                        text: this.$helpers.errorText(error),
                                        color: 'danger',
                                        time: this.$store.getters.notificationDuration
                                    });
                                });
                        }.bind(this)
                    );
            },
            updateParticipationDetails() {
                participantService.updateParticipationDetails(this.model)
                .then(response => {
                    this.$emit("save", this.model);

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    });
                })
                .catch(error => {
                    this.$vs.notify({
                        title: this.$t(
                            'request.response.status.' +
                            this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            async loadEventSettings() {
                try {
                    const result = await this.$api.appSettings.getAppEventSettings();
                    this.eventSettings = result.data;
                } catch (e) {
                    console.log(e.response);
                }
            }
        },
        computed: {
            ...mapGetters(['dateFormat']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            daterangeMinValue() {
                // Липсват настройки
                if (!this.eventSettings) return this.model.accommodationFromTimeUtc ? this.model.accommodationFromTimeUtc : this.model.eventStartDate;

                if (this.eventSettings.accommodationRequestDaterangeLimitToEventsSkip && this.eventSettings.accommodationRequestDaterangeLimitToEventsSkip.includes(this.model.registerEntityId)) {
                    // Налична настройка за скипване на дадено събитие
                    return '';
                }

                console.log(this.eventSettings.accommodationRequestDaterangeMinLimitToFieldRelation);

                switch (this.eventSettings.accommodationRequestDaterangeMinLimitToFieldRelation) {
                    case 'Event_start':
                        return this.model.eventStartDate;
                    case 'Event_Stay_From':
                        return this.model.accommodationFromTimeUtc;
                    default:
                        return '';
                }
            },
            daterangeMaxValue() {
                // Липсват настройки
                if (!this.eventSettings) return this.model.accommodationToTimeUtc ? this.model.accommodationToTimeUtc : this.model.eventEndDate;

                if (this.eventSettings.accommodationRequestDaterangeLimitToEventsSkip && this.eventSettings.accommodationRequestDaterangeLimitToEventsSkip.includes(this.model.registerEntityId)) {
                    // Налична настройка за скипване на дадено събитие
                    return '';
                }

                switch (this.eventSettings.accommodationRequestDaterangeMaxLimitToFieldRelation) {
                    case 'Event_end':
                        return this.model.eventEndDate;
                    case 'Event_Stay_To':
                        return this.model.accommodationToTimeUtc;
                    default:
                        return '';
                }
            },
            customDateFormat() {
                return `{0:${this.dateFormat}}`
            },
        },
        async mounted() {
            await this.loadEventSettings();
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new TempRankingToPersonModel(this.value);
                }
            },
            'model.participationDetails.accommodationRequest.accommodationPlaceId': function (val) {
                let num = Number(val);

                if (isNaN(num) || num <= 0) {
                    this.model.participationDetails.accommodationRequest.accommodationTypeId = ''
                }
            },
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
